<template>
  <div>
    <div :class="{ isBrand: brand }" class="brand-info-header">
      <template>
        <img
          class="brand-image"
          v-if="brand && brand.thumbnailImageUrl != null"
          v-trackevent="{
            action: 'Brand Profile Image Click',
            properties: {
              brand: brand.companyName,
            },
          }"
          :alt="brand.vanityUrlName"
          :src="
            $utils.getCDNURL({
              src: brand.thumbnailImageUrl,
              h: 80,
              w: 69,
              q: 80,
            })
          "
          @click="redirectToBrandPage(brand.vanityUrlName)"
        />
        <img v-else alt="" src="@/assets/img/bulletin-admin-thumbnail.png" srcset="" />
      </template>

      <div class="right-side">
        <template>
          <h3
            class="post-owner"
            v-if="brand"
            v-trackevent="{
              action: 'Brand Profile Image Click',
              properties: {
                brand: brand.companyName,
              },
            }"
            @click="redirectToBrandPage(brand.vanityUrlName)"
          >
            {{ brand.companyName }}
          </h3>
          <h3 v-else class="post-owner">Bulletin</h3>
        </template>

        <div v-if="post.node.brand"></div>

        <div class="buttons-container">
          <follow-button
            v-if="brand && user && user.role === 'RETAILER'"
            :brand-id="brand.id"
            @follow-click="followButtonClicked"
            @unfollow-click="unfollowButtonClicked"
          />
          <chat-button-by-id
            class="chat-button-wrapper"
            v-if="showMessageButton()"
            :brand-id="post.node.brand.id"
            :hide-name="true"
            @handle-click="messageButtonClicked"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";
.brand-info-header {
  display: flex;
  align-items: center;

  .brand-image {
    border-radius: 100px;
    border: 1px solid black;
    width: 91px;
    height: 112px;
    object-fit: cover;

    @include respond-to("small") {
      width: 48px;
      height: 59px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .right-side {
    margin-left: 24px;

    @include respond-to("small") {
      margin-left: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
    }

    .post-owner {
      font-size: 24px;
      line-height: 32px;

      @include respond-to("small") {
        font-size: 18px;
      }

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .buttons-container {
      display: flex;
      margin-top: 12px;

      @include respond-to("small") {
        margin-top: 0;
      }

      .chat-button-wrapper {
        margin-left: 12px;
      }
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import ChatButtonById from "../../components/shared/chatButtonById/chatButtonById.vue";
import InlineSvg from "vue-inline-svg";
import FollowButton from "./TheFollowButton";

export default {
  components: {
    FollowButton,
    ChatButtonById,
    InlineSvg,
  },
  props: {
    brand: {
      type: Object,
    },
    post: {
      type: Object,
    },
    index: {
      type: Number,
      default: 0,
    },
    follow: {
      type: Function,
    },
    unFollow: {
      type: Function,
    },
    feedEvents: {
      type: Object,
    },
  },
  computed: {
    isRetailerApproved() {
      return this.$store.getters.isRetailerApproved;
    },
    ...mapGetters({
      user: "userState",
      plusAccess: "plusAccessState",
    }),
  },
  methods: { redirectToBrandPage, showMessageButton, followButtonClicked, unfollowButtonClicked, messageButtonClicked },
};

function redirectToBrandPage(vanityUrlName) {
  this.$router.push("/brands/" + vanityUrlName);
}

function showMessageButton() {
  if (!this.post?.node?.brand?.id) {
    return;
  }

  return this?.user && this?.user !== "ADMIN" && this?.user !== this.post?.node?.brand?.id;
}

function followButtonClicked() {
  this.feedEvents.track("FOLLOW_BRAND", this.post.node, this.index);
}
function unfollowButtonClicked() {
  this.feedEvents.track("UNFOLLOW_BRAND", this.post.node, this.index);
}

function messageButtonClicked() {
  this.feedEvents.track("MESSAGE_BRAND", this.post.node, this.index);
}
</script>
